document.addEventListener('DOMContentLoaded', function () {
  const faqTriggers = document.querySelectorAll('.s2g-homepage-faqs--faq-trigger');

  faqTriggers.forEach((trigger) => {
    trigger.addEventListener('click', function () {
      const isExpanded = this.getAttribute('aria-expanded') === 'true';
      const contentId = this.getAttribute('aria-controls');
      const content = document.getElementById(contentId);

      // Toggle ARIA attributes
      this.setAttribute('aria-expanded', !isExpanded);

      // Toggle content visibility
      if (isExpanded) {
        content.setAttribute('hidden', '');
      } else {
        content.removeAttribute('hidden');
      }
    });

    // Add keyboard support
    trigger.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        this.click();
      }
    });
  });
});
